import { createState, useState } from '@hookstate/core';
import { Filters } from 'react-table';
import { CustomerManagementGridItem } from 'shared/types';
import { getLocalStorageItem, setLocalStorageItem } from 'shared/utility';

export interface ICustomerFilterState {
  filters: Filters<CustomerManagementGridItem> | undefined;
}

export const defaultCustomerFiltersState: ICustomerFilterState = {
  filters: [],
};
export const CUSTOMER_FILTERS_TABLE_STATE_KEY = 'customer-filters-table-state';

export function getLocalStoredCustomerFiltersState() {
  const value = getLocalStorageItem<ICustomerFilterState>(CUSTOMER_FILTERS_TABLE_STATE_KEY);
  if (!value) {
    setLocalStorageItem<ICustomerFilterState>(CUSTOMER_FILTERS_TABLE_STATE_KEY, defaultCustomerFiltersState);
    return defaultCustomerFiltersState;
  }
  return value;
}

export const storedCustomerFiltersTableState = getLocalStoredCustomerFiltersState();

const customerFiltersState = createState(storedCustomerFiltersTableState);

export function useCustomerFilterState() {
  return useState(customerFiltersState);
}
